import { useEffect, useState } from 'react';
import { DiamondOutlined } from '@mui/icons-material';
import { Box, Divider, Typography } from '@mui/material';
import clsx from 'clsx';

interface PolicyPriceInfoItemViewProps {
  list: any[];
}
const PolicyPriceInfoItemView = (props: PolicyPriceInfoItemViewProps) => {
  const { list } = props;
  const [priceInfoList, setPriceInfoList] = useState([]);

  /**
   * effects
   */
  useEffect(() => {
    // const newList = [[], []];
    // (list || []).forEach((item) => {
    //   if (item.isBoldMore) {
    //     newList[1].push(item);
    //   } else {
    //     newList[0].push(item);
    //   }
    // });
    // setPriceInfoList(newList);
    const newList = [[]];
    (list || []).forEach((item) => {
      if (item.isBoldMore) {
        newList[0].push(item);
      }
    });
    setPriceInfoList(newList);
  }, [list]);

  return (
    <Box className="bg-grey-5 flex flex-1 flex-col space-y-1 overflow-hidden rounded-lg px-1 py-2">
      {priceInfoList.map((list, index) => {
        return (
          <Box key={index} className="flex flex-col">
            {index !== 0 && <Divider key={index} className="bg-grey-5 m-2 h-px" />}
            {list.map((item, aIndex) => {
              return (
                <Box key={aIndex} className="bg-grey-5 flex flex-col px-[8px]">
                  <Box className="flex flex-1 flex-row items-center justify-between">
                    <Typography variant={item.isBoldMore ? 'subtitle1' : 'subtitle2'} className="font-semibold">
                      {item.title}
                    </Typography>
                    <Box className="flex flex-row space-x-1">
                      {item.isPaymentPlan && <DiamondOutlined className="text-brand-primary" />}
                      <Typography
                        variant={item.isBoldMore ? 'subtitle1' : 'subtitle2'}
                        className={clsx('font-bold', item.isPaymentPlan ? 'text-brand-primary' : '')}
                      >
                        {item.content}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
};

export default PolicyPriceInfoItemView;
